import { join } from 'node:path';
import { init, parse } from 'es-module-lexer';
import { readFile } from 'node:fs/promises';

const postfixRE = /[?#].*$/;

const OPTIMIZABLE_ENTRY_RE = /\.[cm]?[jt]s$/;

// prettier-ignore
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const interopHelper = (m: any) => m?.__esModule ? m : { ...(typeof m === 'object' && !Array.isArray(m) || typeof m === 'function' ? m : {}), default: m }

// get line breaks to preserve line count for not breaking source maps
export function getLineBreaks(str: string) {
  return str.includes('\n') ? '\n'.repeat(str.split('\n').length - 1) : '';
}

export function cleanUrl(url: string): string {
  return url.replace(postfixRE, '');
}

export function isViteOptimized(id: string, projectFolder: string): boolean {
  return id.startsWith(join(projectFolder, 'node_modules/.vite/deps_ssr'));
}

export async function shouldOptimizeDependency(url: string) {
  return (
    url.includes('node_modules') &&
    OPTIMIZABLE_ENTRY_RE.test(url) &&
    !(await fileHasModuleSyntax(url))
  );
}

async function fileHasModuleSyntax(filePath: string): Promise<boolean> {
  await init;

  const entryContent = await readFile(filePath, 'utf-8');
  const parseResult = parse(entryContent);

  const [, , , hasModuleSyntax] = parseResult;

  return hasModuleSyntax;
}
